// Theme selection, persisted per viewer.

import { useState, useEffect, useCallback } from 'react';

export const THEMES = ['default', 'tokyo-night', 'gruvbox', 'matrix'];
const STORAGE_KEY = 'portfolio:theme';

const readStored = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return THEMES.includes(stored) ? stored : 'default';
  } catch {
    return 'default';
  }
};

export function useTheme() {
  const [theme, setThemeState] = useState(readStored);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      /* storage unavailable — the theme still applies for this session */
    }
  }, [theme]);

  const setTheme = useCallback((next) => {
    if (!THEMES.includes(next)) return false;
    setThemeState(next);
    return true;
  }, []);

  return { theme, setTheme };
}
